import * as ng from 'angular';
import { ArchiSmallServices } from '../../services/archismall.service';

export class RegistrationController implements ng.IController {

    static $inject: string[] = [
        '$rootScope',
        '$state',
        '$scope',
        'store',
        'ArchiSmallServices'
    ];
    constructor(
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private $scope: any,
        private store: ng.a0.storage.IStoreService,
        private ArchiSmallServices: ArchiSmallServices
    ) {
        $scope.tooltips = {
            'help': 'Ti serve Aiuto? Leggi il Manuale o apri un\nticket e verrai contattato dal Servizio Assistenza.'
        };

        let currentStepName = 'activation-code';
        $scope.init = () => {
            $scope.user = store.get('registeringUser');
            if ($scope.user === undefined) {
                $state.go('registration.activation-code');
                return 0;
            } else {
                return 1;
            }
        };
        $scope.init();

        $scope.registerUser = () => {
            ArchiSmallServices.registerUser($scope.user)
                .then((response: any) => {
                    $scope.user.accountData.lastStepSaved = 'summary';
                    $scope.buttonDisabled = true;
                    store.set('registeredUser', $scope.user);
                    store.remove('registeringUser');
                    $state.go('registration.summary');
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };
        $scope.userDefault = {
            'accountData': {
                'lastStepVisited': '',
                'userType': 0, // 1- Libero Profesionista,2 - Ditta Individuale, 3 - Azienda
                'userTypeName': '',
                'username': '',
                'email': '',
                'PEC': '',
                'password': '',
                'securityQuestion': '',
                'securityAnswer': ''
            },
            'organizationData': {
                'name': '',
                'regimeFiscale': '',
                'titolo': '',
                'codEORI': '',
                'riferimentoAmministrazione': '',
                'inscrizioneREAIncluded': false,
                'alboProfessionaleIncluded': false,
                'rappresentanteFiscaleIncluded': false,
                'address': '',
                'numeroCivico': '',
                'CAP': '',
                'province': '',
                'city': '',
                'country': '',
                'codicePaese': '',
                'phoneNumber': '',
                'mobilePhoneNumber': '',
                'fax': '',
                'PIVA': '',
                'fiscalCode': '',
                'periodStart': '',
                'periodEnd': '',
                'contactPerson': {
                    'firstname': '',
                    'surname': '',
                    'birthDate': '',
                    'birthInItaly': 'Y',
                    'birthCountry': '',
                    'birthProvince': '',
                    'birthCity': '',
                    'identityCardFile': '',
                    'fiscalCodeFile': '',
                    'sex': 'M'
                },
                'authorizePersonalDataTreatment': '',
                'stabileOrganizzazioneAddressIsDifferent': false,
                'inscrizioneREA': {},
                'stabileOrganizzazione': {},
                'alboProfessionale': {},
                'rappresentanteFiscale': {}
            },
            'subscription': {
                'subscriptionType': '',
                'autoRenew': '',
                'activationCode': '',
                'subscriptionStart': '',
                'subscriptionEnd': ''
            },
            'canUseFatturaPA': false,
            'canUseConservazione': false,
            'canUseFattureAttiveStatus': 0
        };

        $scope.startWithLastStepIfPresent = false;
        $rootScope.steps = {
            'registration-type': 0,
            'account-data': 1,
            'organization-data': 2,
            'organization-data-lp': 2,
            'activation-code': 3,
            'subscription': 4,
            'summary': 5
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/registration.controller.ts